import React, { useEffect, useState } from "react";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import { Link, useLocation } from "react-router-dom";
import Http from "../../../Common/Http";
import DatatableFunc from "../../../Common/DatatableFunc";
import Alert from "../../../Common/Alert";

const VendorLedgerSummary = () => {
  const location = useLocation();
  const [bankData, setBankData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  // Format date helper function
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`; // Format as YYYY-MM-DD for HTML date inputs
  };

  // Get current month's first day and today's date
  const getCurrentMonthDates = () => {
    const today = new Date();
    const firstDayOfCurrentMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );

    return {
      firstDate: formatDate(firstDayOfCurrentMonth),
      todayDate: formatDate(today),
    };
  };

  // Initialize date range with current month's first day and today
  const [dateRange, setDateRange] = useState(() => {
    const { firstDate, todayDate } = getCurrentMonthDates();
    return {
      start_date: firstDate,
      end_date: todayDate,
    };
  });

  const fetchData = async () => {
    setLoading(true);

    try {
      // Ensure dates are properly formatted when sending to API
      const params = {
        start_date: dateRange.start_date,
        end_date: dateRange.end_date,
      };

      // const res = await Http.get(`/accounts/get-all-vendor-ledger-summary`, {
      //   params,
      // });
      const res = await Http.get(`/accounts/get-all-vendor-ledger-summary`);
      const resRole = await Http.get(`/staff-type-check`);

      if (res.data && res.data.data) {
        setBankData(res.data.data);
      } else {
        setBankData([]);
        showAlert("No data available for the selected date range", "warning");
      }

      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert(
        "Failed to fetch data: " +
          (error.response?.data?.message || error.message),
        "danger"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;

    setDateRange((prev) => {
      // Validate date range
      if (name === "end_date" && value < prev.start_date) {
        showAlert("End date cannot be earlier than start date", "warning");
        return prev;
      }

      if (name === "start_date" && value > prev.end_date) {
        // If start date is after end date, update end date to match start date
        return {
          start_date: value,
          end_date: value,
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const cols = [
    { field: "name", header: "Vendor Name" },
    { field: "due_payment", header: "Opening Due" },
    { field: "grn", header: "GRN" },
    { field: "grn_return", header: "GRN Return" },
    { field: "vendor_payment", header: "Vendor Payment" },
    { field: "total_balance", header: "Balance" },
  ];

  // const actionTemplate = (item) => {
  //   return (
  //     <td className="text-xs text-center">
  //       <Link
  //         to={{
  //           pathname: "/reports/get-bank-ledger-details/" + item.id,
  //         }}
  //         className="btn btn-info btn-sm ms-1"
  //         title="View Details"
  //       >
  //         <i className="fa fa-list" aria-hidden="true"></i>
  //       </Link>
  //     </td>
  //   );
  // };

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Vendor Ledger</h5>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              {/* Date Filter Form */}
              {/* <div className="mb-4">
                <form onSubmit={handleFilterSubmit} className="row g-3 align-items-end">
                  <div className="col-md-4">
                    <label htmlFor="start_date" className="form-label">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      id="start_date"
                      name="start_date"
                      value={dateRange.start_date}
                      onChange={handleDateChange}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="end_date" className="form-label">End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      id="end_date"
                      name="end_date"
                      value={dateRange.end_date}
                      onChange={handleDateChange}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <button type="submit" className="btn btn-primary">
                      Apply Filter
                    </button>
                  </div>
                </form>
              </div> */}

              <ReactDataTable
                cols={cols}
                receiveData={bankData}
                isLoading={loading}
                // actionTemplate={actionTemplate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorLedgerSummary;
